import React from 'react';
import { columnRenderArrayData } from 'utils/tableUtils';
import GenericPullConfigListing from '../GenericPullConfigListing';
import DependabotCredentialsForm from './DependabotCredentialsForm';
import DependabotMappingForm from './DependabotMappingForm';

const DependabotConfigListing = (props) => {

    const columns = [{
        title: "Repository",
        dataIndex: "repositoryName",
        width: 240,
        render: columnRenderArrayData
    }]

    return (
    <GenericPullConfigListing
        {...props}
        toolName={props.name}
        MappingForm={DependabotMappingForm}
        CredentialsForm={DependabotCredentialsForm}
        extraColumns={columns}
     />
)};

export default DependabotConfigListing;
